"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LeaderboardWrapperStack = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const LeaderboardWrapperStack = ({ children, windowSize, factor, isPWA, fadeIn, embedded = false, bottomPadding = 0, applyAppBarTopMargin = true, }) => {
    const isEmbeddedLayout = embedded;
    const shouldOffsetForAppBar = !isEmbeddedLayout && applyAppBarTopMargin;
    return ((0, jsx_runtime_1.jsx)(material_1.Stack, { direction: 'column', spacing: 0, sx: {
            gap: '3px',
            height: isEmbeddedLayout ? '100%' : '100dvh',
            backgroundColor: 'sepia.background',
            borderRadius: 2,
            alignItems: 'center',
            overflow: 'hidden',
            maxHeight: isEmbeddedLayout
                ? '100%'
                : `calc(100dvh - ${windowSize.appBarHeight + (isPWA ? 10 * factor : 10 * factor)}px - env(safe-area-inset-bottom))`,
            marginTop: shouldOffsetForAppBar ? `${windowSize.appBarHeight}px` : 0,
            paddingBottom: `${bottomPadding}px`,
            display: 'flex',
            flexDirection: 'column',
            opacity: fadeIn ? 1 : 0,
            transition: 'opacity 0.4s ease-in-out',
            //border: '1px solid black',
        }, children: children }));
};
exports.LeaderboardWrapperStack = LeaderboardWrapperStack;
